/* eslint-disable import/prefer-default-export */
export const getVideoPageData = (state: any) => state?.videoTutorial;
